/**
 * Muscle Memory: the top of the column, and the only perk that pulls two levers at once.
 *
 * Two effects on one perk is allowed and stays rare. A capstone earns it; a tier one node pulling
 * three levers would be a bundle rather than a choice.
 */

import type { Perk } from '@/sim/progression/perkContract';

export const MUSCLE_MEMORY = {
  id: 'muscleMemory',
  branch: 'gunplay',
  tier: 4,
  title: 'Muscle Memory',
  blurb: 'Your hands have stopped asking you about it. Do not ask them either.',
  maxRanks: 2,
  minLevel: 25,
  requires: ['snapSight'],
  statGrants: {},
  effects: [
    { field: 'reloadSeconds', perRank: -0.09, condition: null },
    { field: 'adsSeconds', perRank: -0.07, condition: null },
  ],
  damageModifiers: [],
} as const satisfies Perk;
